import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Box, IconButton, MenuItem, Select, Typography, useTheme } from "@mui/material";
import { formatResultCount } from "../utils/formatters";
const RESULTS_PER_PAGE = 25;
const MAX_PAGES = 100;
export const LinkedInPagination = ({ currentPage, totalResults, resultsPerPage = RESULTS_PER_PAGE, onPageChange, isLoading = false, }) => {
    const theme = useTheme();
    // Capped at 100 like LinkedIn's pagination limit
    const calculatedMaxPages = totalResults ? Math.ceil(totalResults / resultsPerPage) : 1;
    const maxPages = Math.min(MAX_PAGES, calculatedMaxPages);
    const rangeStart = (currentPage - 1) * resultsPerPage + 1;
    const rangeEnd = totalResults ? Math.min(currentPage * resultsPerPage, totalResults) : currentPage * resultsPerPage;
    const handlePrevious = () => {
        if (currentPage > 1 && !isLoading) {
            onPageChange(currentPage - 1);
        }
    };
    const handleNext = () => {
        if (currentPage < maxPages && !isLoading) {
            onPageChange(currentPage + 1);
        }
    };
    const handlePageSelect = (page) => {
        if (page !== currentPage && !isLoading) {
            onPageChange(page);
        }
    };
    const pageOptions = Array.from({ length: maxPages }, (_, i) => i + 1);
    return (_jsxs(Box, Object.assign({ sx: {
            display: "flex",
            alignItems: "center",
            gap: 1,
            p: 2,
            borderTop: `1px solid ${theme.palette.divider}`,
        } }, { children: [_jsx(IconButton, Object.assign({ onClick: handlePrevious, disabled: currentPage === 1 || isLoading, size: "small", sx: {
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 1,
                    "&:disabled": {
                        opacity: 0.5,
                    },
                } }, { children: _jsx(ChevronLeft, {}) })), _jsx(Select, Object.assign({ value: currentPage, onChange: (e) => handlePageSelect(Number(e.target.value)), disabled: isLoading, size: "small", sx: {
                    minWidth: 80,
                    "& .MuiSelect-select": {
                        py: 0.75,
                        display: "flex",
                        alignItems: "center",
                    },
                }, MenuProps: {
                    PaperProps: {
                        sx: {
                            maxHeight: 300,
                        },
                    },
                } }, { children: pageOptions.map((page) => (_jsx(MenuItem, Object.assign({ value: page }, { children: page }), page))) })), _jsx(IconButton, Object.assign({ onClick: handleNext, disabled: currentPage >= maxPages || isLoading, size: "small", sx: {
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 1,
                    "&:disabled": {
                        opacity: 0.5,
                    },
                } }, { children: _jsx(ChevronRight, {}) })), _jsx(Typography, Object.assign({ variant: "body2", color: "text.secondary", sx: { ml: 2 } }, { children: totalResults !== null ? (_jsxs(_Fragment, { children: [rangeStart, " - ", rangeEnd, " of ", formatResultCount(totalResults)] })) : (_jsxs(_Fragment, { children: [rangeStart, " - ", rangeEnd] })) }))] })));
};
